import ErrorBox from './ErrorBox';
import InputForm from '../molecules/InputForm';
import ButtonLabel from '../atoms/ButtonLabel';
import { Button, ButtonContainer, FormWrapper } from '../atoms/EditFormContent';
import styled from 'styled-components';
import { fontSize } from '../utils/style/font';
import space from '../utils/style/space';
import i18n from '../R/string/i18n';
import { ChangeEvent, FormEvent } from 'react';

const NoteText = styled.div`
  margin-top: ${space.xxxs}px;
  font-size: ${fontSize.m}px;
`;

type Props = {
  lastName: string;
  firstName: string;
  onChangeLastName: (event: ChangeEvent<HTMLInputElement>) => void;
  onChangeFirstName: (event: ChangeEvent<HTMLInputElement>) => void;
  lastNameErr?: string;
  firstNameErr?: string;
  serverErrMsg: string;
  updateEnabled: boolean;
  onUpdateName: (event: FormEvent<HTMLFormElement>) => void;
};

const UpdateUserNameForm = ({
  lastName,
  firstName,
  onChangeLastName,
  onChangeFirstName,
  lastNameErr,
  firstNameErr,
  serverErrMsg,
  updateEnabled,
  onUpdateName
}: Props) => (
  <>
    <ErrorBox message={serverErrMsg} />
    <FormWrapper onSubmit={onUpdateName}>
      <div>
        <InputForm
          label={i18n.userNameEditFormFamilyName()}
          type="text"
          value={lastName}
          onChange={onChangeLastName}
          errorMessage={lastNameErr}
          placeholder={i18n.userNameEditFormFamilyName()}
        />
        <NoteText>
          {i18n.userNameEditFormEnterAlphabetsWithoutSymbols()}
        </NoteText>
      </div>
      <InputForm
        label={i18n.userNameEditFormFirstName()}
        type="text"
        value={firstName}
        onChange={onChangeFirstName}
        errorMessage={firstNameErr}
        placeholder={i18n.userNameEditFormFirstName()}
      />
      <ButtonContainer>
        <Button type="submit" disabled={updateEnabled}>
          <ButtonLabel>{i18n.commonSave()}</ButtonLabel>
        </Button>
      </ButtonContainer>
    </FormWrapper>
  </>
);
export default UpdateUserNameForm;
